import React from 'react';
import {useTranslation} from 'react-i18next';
import FilterIcon from '../../../../../../assets/icons/FilterIcon';
import List from '../../../../../../component/list/List';
import SmartSearchOnList from '../../../../../components/smartSearchOnList/SmartSearchOnList';
import * as css from './SearchFilterComponent.css';
import {SearchFilterComponentProps} from '../../utils/types';
import {TShow} from '../../../../../../component/prompotionPopup/PromotionPopup';
import {getStatusFilterOptions, getCategoryFilterOptions, getStatusText, getCategoryFilterText} from '../../utils/utils';
import useShow from '../../../../../../hooks/useShow';
import {useSelector} from 'react-redux';
import useMobile from '../../../../../../hooks/useMobile';

function SearchFilterComponent({statusFilter, categoryFilter, events, onStatusFilterChange, onCategoryFilterChange, onSearchChange}: SearchFilterComponentProps) {
    const {t} = useTranslation('subscriptions');
    const statusListShow = useShow();
    const categoryListShow = useShow(); 
    const {eventCategories} = useSelector((s: any) => s.categories);
    const isMobile = useMobile();
    
    // Filter options for List components using utility functions
    const statusOptions = getStatusFilterOptions(onStatusFilterChange, statusListShow.close, t);
    const categoryOptions = getCategoryFilterOptions(eventCategories, onCategoryFilterChange, categoryListShow.close, t);

    const toggleList = (listShow: TShow) => {
        if(listShow.isOpen) {
            listShow.close();
        } else {
            listShow.open();
        }
    };
    return (
        <css.searchSection>
            <css.filterDropdowns>
                {!isMobile && <css.filterIcon>
                    <FilterIcon />
                </css.filterIcon>}
                <css.filterButton data-cy="assign-events-status-filter-btn" onClick={() => toggleList(statusListShow)}>
                    {getStatusText(statusFilter, t)}
                </css.filterButton>
                {statusListShow.isOpen && <List
                    list={statusOptions}
                    showClass={statusListShow.showClass}
                    close={statusListShow.close}
                    width="200px"
                    top={30}
                    right={'30px'}
                />}
                <css.filterButton data-cy="assign-events-category-filter-btn" onClick={() => toggleList(categoryListShow)}>
                    {getCategoryFilterText(categoryFilter, eventCategories, t)}
                </css.filterButton>
                {categoryListShow.isOpen && <List
                    list={categoryOptions}
                    showClass={categoryListShow.showClass}
                    close={categoryListShow.close}
                    width="200px"
                    top={30}
                    right={'160px'}
                />}
            </css.filterDropdowns>
            <SmartSearchOnList
                list={events}
                searchColumns={['title', 'location', 'category']}
                setSearchArray={() => {}}
                notLocalSearch={async (_list, searchValue) => onSearchChange(searchValue)}
            />
        </css.searchSection>
    );
}

export default SearchFilterComponent;
